import { EmptyState } from '@dev-spendesk/grapes';
import React from 'react';

import { useTranslation } from 'common/hooks/useTranslation';

export const AccountingIntegrationSwitchInProgressFeedback = () => {
  const { t } = useTranslation('global');

  return (
    <div className="mx-auto flex w-full max-w-[1000px] flex-col p-24">
      <EmptyState
        iconName="arrow-path"
        iconVariant="info"
        title={t('bookkeep.integrations.settings.baseSwitch.switchingTitle')}
        subtitle={t(
          'bookkeep.integrations.settings.baseSwitch.switchingSubtitleFileBased',
        )}
      />
    </div>
  );
};
